// extracted by mini-css-extract-plugin
export var dropdownIcon = "_lj-6";
export var imgContainer = "_lj-3";
export var menuIcon = "_lj-5";
export var pillWrapper = "_lj-2";
export var pillsContainer = "_lj-1";
export var subscriptionCard = "_lj-0";
export var subscriptionLogo = "_lj-4";